module.exports = {
  type: 'spa',
  isTenanted: true,
  publicPath: '/sp-dashboard/',
  octopusPackageId: 'supplier-dashboard',
  octopusProjectName: 'Supplier Dashboard',
  mountDOMId: '__sp_dashboard__',
  standalone: true
};